var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade flexbox",
      attrs: { id: "modal-amazon-expiration", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body text-center" }, [
            _c("h3", { staticClass: "text-danger body-title" }, [
              _vm._v("Amazonとのデータ連携を行ってください")
            ]),
            _vm._v(" "),
            this.amazonExpirationContext.length
              ? _c(
                  "div",
                  { staticClass: "box-context" },
                  _vm._l(_vm.amazonExpirationContext, function(item, index) {
                    return _c("div", { key: index }, [
                      _c("div", { class: item.classes }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn w-200",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [_vm._v("このまま利用する")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-warning w-200",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.handleClick()
                    }
                  }
                },
                [_vm._v("設定画面に移動する")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1edc88a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1edc88a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAmazonExpiration.vue
// module id = null
// module chunks = 